export class SurveySetting {
    zarca_id: number;
    MaxPageNo: number;
    TotalQuestions: number;
    SurveyHeader: string;
    SurveyFooter: string;
    SurveyLogoImageUrl: string;
    SurveyLogoAlign: number;
    Responses: number;
    txtQuestionIds: string;
    PipingQtitle: string;
    txtQuestionOnPage: string;
    txtBranchedPages: string;
    hdnallquestion: string;
    hdnAssessSettings: boolean;
    blnOnlyCmtAndCaptcha: boolean;
    isShowBack: boolean;
    surveyWidthType: number;
    isclearanswers: boolean;
    primary_lang_id: number;
    displaypagenumber: boolean;
    //selectedLangId: number;
    SurveytemplateName: string;
    isMandatoryUpfront: string;
    IsEditLater: string;
    SurveyTitle: string;
    isReopenResponse: boolean;
    ReopenText: string;
    isSubscriptionModel : boolean;
    //isSurveyExpired :boolean;
    isMobile: boolean;
    isOverAllStyleAppliedToHeader: boolean;
    isOverAllStyleAppliedToFooter: boolean;
    //LastEditTimeStamp: string;
    questionSpacer: number;
    isAssessment: boolean;
    IsShowScore:boolean;
    SurveyTimeLimit :number;
    IsShowTimerOnParticipation :boolean;
    IsSemiAnonymous : boolean
    IsAnonymous :boolean
    SurveyBackgroundImage :string
    DisplayQno : boolean
    isEx:boolean
    isEmbedPrePop: boolean;
    isAngularSurvey: boolean;
    isDarkTheme: boolean;
    isLaunchNow: boolean;
    isLaunchNowEnabled: boolean;
    EncZarcaID : string;
    CustomScript:string;
}


export class PreviewData {
    isManditorySkip: boolean;
    isByPassLogic: boolean;
    isShowHiddenQN: boolean;
    isPrevPgChnge: boolean;
    PrevPgNo: number;
    isPagePreview: boolean;
    isPreviewToggle:boolean;
    surveyFormat: number;
    isFromSB:string;
}

export class CommonSetting {
    isMobileDevice: boolean;
    isTablet:boolean;
    isEmbedMobile: number;
    isEmbedPopMobile: number;
    isEmbedPopWeb: number;
    embedLangOpt: number;   
    productName:string;
    strTick:string;
    cp_no:number;
    dropDownCount:number
    ImageFolder:string;
    SurveyURL:string;
    cookieCorpNO:string
    MDDdropDownCount:number;
    SurveyFileUploadFolder: string;
    isEmbedNoScroll:boolean;
    embedDefaultPx:number;
    embedPopQSpacer:number;
    isEmbed:number;
    embedID:number;

}

export class SignUp {
    accountType: string;
    signInType: boolean;
    strHostPath: string;
    ref: string;
    strParticipationServer: string;
    FaceBookID:string;
}

export class OfflineSurvey {
    isOfflineSurvey: boolean;
    Surveytimeout: number;
    Thankyoumessagetimeout: number;
    isOfflineEnable: boolean;
    OfflineURLID:number;
    surveyTitle:string;
    corp_mailid:string;
    surveyno:string;
    primaryLang: string;
}
